import { Card, Text, Flex, Box } from '@radix-ui/themes'
import { CheckCircle2, Clock, XCircle } from 'lucide-react'

import { TransferStatus, TransferStatusEntry, TRANSFER_STATUS_LABELS } from '@/interfaces/Transfer'

interface TransferStatusTimelineProps {
  statusHistory: TransferStatusEntry[]
}

const getStatusIcon = (status: TransferStatus) => {
  switch (status) {
    case TransferStatus.VOIDED:
    case TransferStatus.REJECTED:
      return <XCircle className="w-5 h-5 text-red-500" />
    case TransferStatus.NOTARIZED:
    case TransferStatus.REGISTERED:
    case TransferStatus.PAID:
      return <CheckCircle2 className="w-5 h-5 text-green-500" />
    default:
      return <Clock className="w-5 h-5 text-blue-500" />
  }
}

export const TransferStatusTimeline = ({ statusHistory }: TransferStatusTimelineProps) => {
  if (!statusHistory || statusHistory.length === 0) {
    return (
      <Text size="2" color="gray">
        Sin historial de estado
      </Text>
    )
  }

  return (
    <Card>
      <Flex direction="column" gap="3" p="3">
        <Text size="3" weight="bold">
          Historial de estado
        </Text>
        <Box>
          {statusHistory.map((entry, index) => {
            const date = new Date(entry.timestamp)
            const isLast = index === statusHistory.length - 1

            return (
              <Flex key={index} gap="3" align="start" className="relative">
                {/* Timeline line */}
                {!isLast && <Box className="absolute left-[9px] top-6 w-0.5 h-full bg-gray-200" />}
                {/* Icon */}
                <Box className="z-10 bg-white">{getStatusIcon(entry.status)}</Box>
                {/* Content */}
                <Flex direction="column" gap="1" pb="4">
                  <Text size="2" weight="medium">
                    {TRANSFER_STATUS_LABELS[entry.status] || entry.status}
                  </Text>
                  {entry.note && (
                    <Text size="1" color="gray">
                      {entry.note}
                    </Text>
                  )}
                  <Text size="1" color="gray">
                    {date.toLocaleDateString('es-CL')} {date.toLocaleTimeString('es-CL')}
                  </Text>
                </Flex>
              </Flex>
            )
          })}
        </Box>
      </Flex>
    </Card>
  )
}
